import { selectApiData, selectApiNoContent } from 'util/selector/apiSelector';

import { ApiMessage } from 'api/const';
import { WithData } from 'api/interfaces';
import { AxiosInstance } from 'axios';

import { PageDto } from './dto/Page.dto';

export class PageApi {
  constructor(private client: AxiosInstance) {}

  list(projectId: number): Promise<PageDto[]> {
    return this.client
      .get<WithData<PageDto[]>>(`/api/v1/project/${projectId}/page`)
      .then(selectApiData);
  }

  create(projectId: number, page: PageDto): Promise<PageDto> {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { id, ...data } = page;

    return this.client
      .post(`/api/v1/project/${projectId}/page`, {
        ...data,
      })
      .then(selectApiData);
  }

  update(page: PageDto): Promise<PageDto> {
    const { id, ...data } = page;

    return this.client
      .post<WithData<PageDto>>(`/api/v1/page/${id}`, { ...data })
      .then(selectApiData);
  }

  delete(pageId: number): Promise<void> {
    return this.client
      .delete<ApiMessage.Deleted>(`/api/v1/page/${pageId}`)
      .then(selectApiNoContent);
  }

  reorderItems(pageId: number, order: number[]): Promise<any> {
    return this.client.post(`/api/v1/page/${pageId}/reorder-items`, { order });
  }
}
